export default {
    name: 'downloadFile',
    data () {
        return {}
    },
    computed: {},
    created () {},
    mounted () {},
    methods: {
        downloadFileFromResponse (response, _alt_filename, ext='xlsx') {
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const fileObjectUrl = window.URL.createObjectURL(blob)

            // blob 객체 URL을 설정할 링크를 만듬
            const link = document.createElement("a");
            link.href = fileObjectUrl;
            link.style.display = "none";

            // 다운로드 파일 이름을 지정 할 수 있음
            // 일반적으로 서버에서 전달해준 파일 이름은 응답 Header의 Content-Disposition에 설정됨.
            let filename = this.extractDownloadFilename(response);
            filename = !filename ? _alt_filename : filename

            // if (!ext.includes('.')) ext = `.${ext}`
            // link.setAttribute('download', `${filename}${ext}`);
            link.setAttribute('download', filename);

            document.body.appendChild(link);
            link.click();
            link.remove();

            // 다운로드가 끝난 리소스(객체 URL)를 해제
            window.URL.revokeObjectURL(fileObjectUrl);
        },
        extractDownloadFilename (response) {
            const disposition = response.headers["content-disposition"];
            if (typeof disposition === 'undefined') {
                return null
            } else {
                const fileName = decodeURI(
                disposition
                    .match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1]
                    .replace(/['"]/g, "")
                );
                
                return fileName;
            }
        }
    }
}